import { gsap } from "../../animations/gsapSetup.ts";
import { CTAButton } from "../../components/common/CTAButton.tsx";
import { useGsapScrollTrigger } from "../../hooks/useGsapScrollTrigger.ts";
import { useReducedMotion } from "../../hooks/useReducedMotion.ts";
import { useI18n } from "../../i18n/context.tsx";
import styles from "./ClassicCTA.module.css";

export function ClassicCTA() {
  const reducedMotion = useReducedMotion();
  const { t } = useI18n();

  const ref = useGsapScrollTrigger((el) => {
    if (reducedMotion) return;

    const content = el.querySelector(`.${styles.content}`);

    gsap.from(content, {
      scale: 0.9,
      opacity: 0,
      duration: 1,
      ease: "power3.out",
      scrollTrigger: {
        trigger: el,
        start: "top 75%",
        toggleActions: "play none none reverse",
      },
    });
  });

  return (
    <section ref={ref} className={styles.section}>
      <div className={styles.content}>
        <h2 className={styles.title}>{t.classic.ctaTitle}</h2>
        <div className={styles.actions}>
          <div className={styles.badge} aria-label="Download on the App Store">
            <svg
              className={styles.badgeSvg}
              viewBox="0 0 120 40"
              fill="none"
              role="img"
              aria-label="App Store badge"
            >
              <rect width="120" height="40" rx="6" fill="#fff" fillOpacity="0.1" />
              <text
                x="60"
                y="16"
                textAnchor="middle"
                fill="#fff"
                fontSize="7"
                fontFamily="var(--font-text)"
              >
                Download on the
              </text>
              <text
                x="60"
                y="29"
                textAnchor="middle"
                fill="#fff"
                fontSize="12"
                fontWeight="600"
                fontFamily="var(--font-display)"
              >
                App Store
              </text>
            </svg>
          </div>
          <CTAButton href="#" variant="classic">
            {t.classic.ctaButton}
          </CTAButton>
          <p className={styles.subtitle}>{t.classic.ctaNote}</p>
        </div>
      </div>
    </section>
  );
}
